import { createSlice } from "@reduxjs/toolkit";
import { CreateAppData } from "../types/CreateAppType";
import { createLocalBankAction } from "../action/createLocalBankAction";
import { createManyCorrBankAction } from "../action/createManyCorrBankAction";

const initialState: CreateAppData = {
  data: null,
  loading: false,
  error: null,
};

const createManyCorrBankSlice = createSlice({
  name: "createManyCorrBankSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createManyCorrBankAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createManyCorrBankAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createManyCorrBankAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const createManyCorrBankReducer = createManyCorrBankSlice.reducer;
